export const AREA_TYPES = [
    {
        value: 'VILLAGE',
        label: 'VILLAGE',
    },
    {
        value: 'MUNICIPAL_CORPORATION',
        label: 'MUNICIPAL_CORPORATION',
    },
];

export default {
    AREA_TYPES,
};
